import React, { useState, useEffect } from "react";
import { WifiOff } from "lucide-react";

const NetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
    };
    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (isOnline) return null;

  return (
    <div
      className="network-status-indicator"
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "#1f1f1f",
        color: "white",
        padding: "12px 24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "15px",
        zIndex: 99999,
        boxShadow: "0 -2px 10px rgba(0,0,0,0.5)",
        borderTop: "3px solid #ff4d4f",
      }}
    >
      <WifiOff size={20} color="#ff4d4f" />
      <div style={{ display: "flex", flexDirection: "column" }}>
        <span style={{ fontWeight: "bold", fontSize: "14px" }}>
          Internet Connection Lost
        </span>
        <span style={{ fontSize: "12px", opacity: 0.8 }}>
          No internet connection. Please reconnect to continue using the
          application.
        </span>
      </div>
      <button
        onClick={() => window.location.reload()}
        style={{
          backgroundColor: "#ff4d4f",
          color: "white",
          border: "none",
          padding: "6px 16px",
          borderRadius: "4px",
          cursor: "pointer",
          fontSize: "12px",
          fontWeight: "600",
          marginLeft: "20px",
          transition: "background 0.2s",
        }}
        onMouseOver={(e) => (e.target.style.backgroundColor = "#ff7875")}
        onMouseOut={(e) => (e.target.style.backgroundColor = "#ff4d4f")}
      >
        Retry Connection
      </button>
    </div>
  );
};

export default NetworkStatus;
